import { i18n } from '@fs/zion-locale'

export default {
  archivalReferenceNumber: () => i18n.t('ChangeHistory.archivalReferenceNumber', 'Archival Reference Number'),
  archivalReferenceNumberRemoved: () =>
    i18n.t('ChangeHistory.archivalReferenceNumberRemoved', 'The Archival Reference Number was removed.'),
  backButtonText: () => i18n.t('ChangeHistory.backButtonText', 'Back'),
  by: () => i18n.t('ChangeHistory.by', 'by'),
  cancel: () => i18n.t('common-ui:cancel.action'),
  changedAt: (time, user) => i18n.t('ChangeHistory.changedAt', 'Changed at {time} by {user}', { time, user }),
  changeHistorySub: () => i18n.t('ChangeHistory.changeHistorySub', 'Changes to Image Group Data'),
  changeHistoryTitle: () => i18n.t('ChangeHistory.changeHistoryTitle', 'Change History'),
  creator: () => i18n.t('ChangeHistory.creator', 'Creator'),
  creatorRemoved: () => i18n.t('ChangeHistory.creatorRemoved', 'Creator Removed'),
  currentVersion: () => i18n.t('ChangeHistory.currentVersion', 'Current Version'),
  currentVersionDescription: () =>
    i18n.t(
      'ChangeHistory.currentVersionDescription',
      'This is the latest metadata so the Restore button is not available.'
    ),
  dateAndTimeSelect: () => i18n.t('ChangeHistory.dateAndTimeSelect', 'Date and Time of Change'),
  errorRestoreMessage: () => i18n.t('ChangeHistory.errorRestoreMessage', 'Error restoring changes'),
  failureRestoreMessage: () =>
    i18n.t('ChangeHistory.failureRestoreMessage', 'Some fields may not have restored properly. Please double check.'),
  languages: () => i18n.t('common-ui:language.label', 'Language'),
  languagesRemoved: () => i18n.t('ChangeHistory.languagesRemoved', 'The language was removed.'),
  lastChangedBy: (date, user) =>
    i18n.t('ChangeHistory.LastChangedBy', 'Last Changed: {date} by {user}', { date, user }),
  loadChangeHistory: () => i18n.t('ChangeHistory.loadChangeHistory', 'Load Change History'),
  next: () => i18n.t('ChangeHistory.next', 'Next'),
  none: () => i18n.t('ChangeHistory.none', 'none'),
  previous: () => i18n.t('ChangeHistory.previous', 'Previous'),
  restoreDialogHeader: () => i18n.t('ChangeHistory.restoreDialogHeader', 'Restore a previous version'),
  restore: () => i18n.t('ChangeHistory.restore', 'Restore'),
  restoreVolume: () => i18n.t('ChangeHistory.restoreVolume', 'Restore Volume'),
  removeVolume: () => i18n.t('ChangeHistory.removeVolume', 'Remove Volume'),
  selectLabel: () => i18n.t('ChangeHistory.selectLabel', 'Change date and time'),
  showHistoryButtonText: () => i18n.t('ChangeHistory.ShowHistoryButtonText', 'Show Change History'),
  successRestoreMessage: () => i18n.t('ChangeHistory.successRestoreMessage', 'Successfully restored changes'),
  title: () => i18n.t('common-ui:title.item', 'Title'),
  titleRemoved: () => i18n.t('ChangeHistory.titleRemoved', 'The title was removed.'),
  unknown: () => i18n.t('ChangeHistory.unknown', 'Unknown'),
  volumes: () => i18n.t('ChangeHistory.volume', 'Volume'),
  volumesRemoved: () => i18n.t('ChangeHistory.volumeRemoved', 'The volume was removed.'),
}
